import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "@/components/Logo";
import Footer from "@/components/Footer";

export function LegalPage({ title, updated, children }) {
  return (
    <>
      {/* Simple header */}
      <header className="bg-navy-deep text-white">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 py-6 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link">
            <Logo dark markSize={32} />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-gold text-sm"
          >
            <ArrowLeft size={16} /> Back to home
          </Link>
        </div>
      </header>

      <article className="bg-paper py-16 sm:py-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <div className="text-xs uppercase tracking-[0.25em] text-gold">
            Legal
          </div>
          <h1 className="mt-4 font-display font-bold text-navy leading-[1.05] text-3xl sm:text-5xl">
            {title}
          </h1>
          <p className="mt-3 text-ink/50 text-sm">
            Last updated: {updated}
          </p>
          <div className="mt-10 prose prose-lg max-w-none text-ink/80 leading-relaxed space-y-6 [&>h2]:font-display [&>h2]:text-navy [&>h2]:text-2xl [&>h2]:font-semibold [&>h2]:mt-10 [&>h3]:font-display [&>h3]:text-navy [&>h3]:text-xl [&>h3]:mt-6 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:space-y-2 [&>p]:leading-relaxed">
            {children}
          </div>
        </div>
      </article>

      <Footer />
    </>
  );
}

export default LegalPage;
